export enum AiProvider {
    ChatGpt = 'chatgpt',
    Claude = 'claude',
    Watsonx = 'watsonx',
    Deepgram = 'deepgram',
    InternalLiveAgent = 'internal_live_agent',
    Mastra = 'mastra'
}
